import { z } from 'zod';
import { type AppRoute } from '@ts-rest/core';

export const ping = {
  method: 'GET',
  path: '/ping',
  responses: {
    200: z.string(),
  },
} as const satisfies AppRoute;
